import { REVIEWER_DETAILS_KEY } from '../constants/storage.constants';
import { IReviewerDetails } from '../interfaces/reviewerInterface';

export const reviewerStorage = {
  setReviewer: (reviewerData: IReviewerDetails) => localStorage.setItem(REVIEWER_DETAILS_KEY, JSON.stringify(reviewerData)),
  getReviewer: (): IReviewerDetails | null => {
    const reviewer = localStorage.getItem(REVIEWER_DETAILS_KEY);
    return reviewer ? JSON.parse(reviewer) as IReviewerDetails : null;
  }
};
